<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    @click:outside="resetPaymentMethod"
  >
    <v-card flat>
      <v-card-title>
        Edit Payment Method
        <v-spacer></v-spacer>
        <v-btn icon @click="resetPaymentMethod">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <div id="card-element" class="pa-4 rounded-lg border--lighttext">
                <!-- A Stripe Element will be inserted here. -->
              </div>

              <!-- Used to display Element errors. -->
              <div role="alert">{{ error }}</div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn :loading="saving" @click="save" :disabled="error.length > 0">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "AddPaymentMethod",
  components: {},
  data: () => ({
    error: "",
    stripe: null,
    elements: null,
    card: null,
    dialog: false,
    valid: false,
    saving: false
  }),
  computed: {
    ...mapGetters({})
  },
  methods: {
    resetPaymentMethod() {
      this.dialog = false;
    },
    showDialog() {
      this.dialog = true;
      this.loadCard();
    },
    loadCard() {
      loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY).then(res => {
        this.stripe = res;
        this.elements = this.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        const style = {
          base: {
            // Add your base input styles here. For example:
            fontSize: "16px",
            color: "#32325d"
          }
        };

        // Create an instance of the card Element.
        this.card = this.elements.create("card", { style });

        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount("#card-element");

        // Monitor change events on the Card Element to display any errors.
        this.card.on("change", ({ error }) => {
          if (error) {
            this.error = error.message;
          } else {
            this.error = "";
          }
        });
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        const { token, error } = await this.stripe.createToken(this.card);

        if (error) {
          // Inform the customer that there was an error.
          this.error = error.message;
          this.saving = false;
        } else {
          // Send the token to your server.
          this.$store
            .dispatch("billing/addPaymentMethod", { tokenId: token.id })
            .then(() => {
              this.$emit("save");

              this.$root.$snackbarSuccess("Payment method added");
              this.dialog = false;
            })
            .catch(error => {
              this.logError(error);
              this.$root.$alert(
                "Error Occurred",
                "An error occurred while adding a payment method."
              );
            })
            .finally(() => {
              this.saving = false;
            });
        }
      }
    }
  }
};
</script>
